import { useState, useEffect } from "react";
import pronouns from "../pronouns.js";

const SymbolBox = ({ selected, width = 200 }) => {
  const [pronounImage, setPronounImage] = useState(""); // State to store the pronoun image source
  const pronounComponents = pronouns();
  useEffect(() => {
    const getPronoun = () => {
      if (selected.includes("na")) {
        return pronounComponents["na"];
      }
      const asString = selected.sort().join("_");
      return pronounComponents[asString];
    };

    // Update the pronoun image source when 'selected' prop changes
    setPronounImage(getPronoun());
  }, [selected]);

  return <div>{pronounImage && pronounImage}</div>;
};

export default SymbolBox;
